"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubmitTimeWorkedDto = instanceOfSubmitTimeWorkedDto;
exports.SubmitTimeWorkedDtoFromJSON = SubmitTimeWorkedDtoFromJSON;
exports.SubmitTimeWorkedDtoFromJSONTyped = SubmitTimeWorkedDtoFromJSONTyped;
exports.SubmitTimeWorkedDtoToJSON = SubmitTimeWorkedDtoToJSON;
exports.SubmitTimeWorkedDtoToJSONTyped = SubmitTimeWorkedDtoToJSONTyped;
const ClockEntryDto_1 = require("./ClockEntryDto");
/**
 * Check if a given object implements the SubmitTimeWorkedDto interface.
 */
function instanceOfSubmitTimeWorkedDto(value) {
    if (!('didNotWork' in value) || value['didNotWork'] === undefined)
        return false;
    if (!('clockEntries' in value) || value['clockEntries'] === undefined)
        return false;
    return true;
}
function SubmitTimeWorkedDtoFromJSON(json) {
    return SubmitTimeWorkedDtoFromJSONTyped(json, false);
}
function SubmitTimeWorkedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'didNotWork': json['didNotWork'],
        'onCallStartTime': json['onCallStartTime'] == null ? undefined : json['onCallStartTime'],
        'onCallEndTime': json['onCallEndTime'] == null ? undefined : json['onCallEndTime'],
        'clockEntries': (json['clockEntries'].map(ClockEntryDto_1.ClockEntryDtoFromJSON)),
        'skippedMealBreakComment': json['skippedMealBreakComment'] == null ? undefined : json['skippedMealBreakComment'],
    };
}
function SubmitTimeWorkedDtoToJSON(json) {
    return SubmitTimeWorkedDtoToJSONTyped(json, false);
}
function SubmitTimeWorkedDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'didNotWork': value['didNotWork'],
        'onCallStartTime': value['onCallStartTime'],
        'onCallEndTime': value['onCallEndTime'],
        'clockEntries': (value['clockEntries'].map(ClockEntryDto_1.ClockEntryDtoToJSON)),
        'skippedMealBreakComment': value['skippedMealBreakComment'],
    };
}
//# sourceMappingURL=SubmitTimeWorkedDto.js.map